export * from "./IEventListConnection";
//# sourceMappingURL=index.js.map